export interface IChangePasswordInitials {
  oldPassword: string;
  password: string;
  passwordCompare: string;
  // ChangePasswordPeriod: number | null;
}

export const userFilterInitials = {
  userName: "",
  email: "",
  groupId: "",
};

export const changePasswordInitials: IChangePasswordInitials = {
  oldPassword: "",
  password: "",
  passwordCompare: "",
  // ChangePasswordPeriod: 0,
};

export const resetPasswordInitials = {
  customerCode: "",
  email: "",
  code: "",
  password: "",
  // changePasswordPeriod: null,
  passwordCompare: "",
};

export interface IResetPasswordInitials {
  customerCode: string;
  email: string;
  code: string;
  password: string;
  passwordCompare: string;
  // changePasswordPeriod: any;
}
